interface ConflictRule {
  id: number;
  carrier_code: string;
  booking_code: string | null;
  fare_family: string;
  gds: string | null;
  correct_shelve: string;
  confirmed: string;
}

interface Props {
  conflictingRules: ConflictRule[];
}

export function ConflictWarning({ conflictingRules }: Props) {
  if (conflictingRules.length === 0) return null;

  return (
    <div className="bg-red-50 border border-red-300 rounded-md p-3 text-sm text-red-800">
      <p className="font-semibold mb-1">Conflict detected!</p>
      <p className="mb-2">
        The following existing rule(s) map the same key to a different shelf:
      </p>
      <ul className="list-disc ml-4 space-y-1">
        {conflictingRules.map((r) => (
          <li key={r.id}>
            <span className="font-mono">
              #{r.id}: {r.carrier_code} / {r.fare_family}
              {r.booking_code ? ` [${r.booking_code}]` : ''}
              {r.gds ? ` (${r.gds})` : ''}
            </span>{' '}
            &rarr; <strong>{r.correct_shelve}</strong> ({r.confirmed})
          </li>
        ))}
      </ul>
    </div>
  );
}
